import { render, staticRenderFns } from "./About.vue?vue&type=template&id=22af2fc5&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=22af2fc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af2fc5",
  null
  
)

export default component.exports